/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable brands
import { tableSchemaBase as columns } from '../brands.columns';
import { tableSchemaBase as columnsForPartner } from '../brandsForPartner.columns';
import { tableSchemaBase as columnsForProducer } from '../brandsForProducer.columns';
import { tableSchemaBase as columnsWithoutContact } from '../brandsWithoutContact.columns';
import { tableSchemaBase as columnsWithoutOrganization } from '../brandsWithoutOrganization.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IBrandsDatatableSlice {
	brandsDatatableOptions: TColumnsSchema[];
	setBrandsDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) => void;

	brandsWithoutContactDatatableOptions: TColumnsSchema[];
	setBrandsWithoutContactDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) => void;

	brandsWithoutOrganizationDatatableOptions: TColumnsSchema[];
	setBrandsWithoutOrganizationDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) => void;

	brandsForPartnerDatatableOptions: TColumnsSchema[];
	setBrandsForPartnerDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) => void;

	brandsForProducerDatatableOptions: TColumnsSchema[];
	setBrandsForProducerDatatableOptions: (
		_brandsDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeBrandsDatatableSlice = (
	s: any
): any => ({
	brandsDatatableOptions: s.brandsDatatableOptions,
	brandsWithoutContactDatatableOptions:
		s.brandsWithoutContactDatatableOptions,
	brandsWithoutOrganizationDatatableOptions:
		s.brandsWithoutOrganizationDatatableOptions,
	brandsForPartnerDatatableOptions:
		s.brandsForPartnerDatatableOptions,
	brandsForProducerDatatableOptions:
		s.brandsForProducerDatatableOptions,
});

const initialState = {
	brandsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
	brandsWithoutContactDatatableOptions:
		columnsWithoutContact.filter(
			(item) => item.defaultVisible
		),
	brandsWithoutOrganizationDatatableOptions:
		columnsWithoutOrganization.filter(
			(item) => item.defaultVisible
		),
	brandsForPartnerDatatableOptions:
		columnsForPartner.filter(
			(item) => item.defaultVisible
		),
	brandsForProducerDatatableOptions:
		columnsForProducer.filter(
			(item) => item.defaultVisible
		),
};

export const createBrandsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', unknown]],
	[],
	IBrandsDatatableSlice
> = (set) => ({
	...initialState,

	setBrandsDatatableOptions: (
		options: TColumnsSchema[]
	) => set({ brandsDatatableOptions: options }),

	setBrandsWithoutContactDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			brandsWithoutContactDatatableOptions: options,
		}),

	setBrandsWithoutOrganizationDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			brandsWithoutOrganizationDatatableOptions: options,
		}),

	setBrandsForPartnerDatatableOptions: (
		options: TColumnsSchema[]
	) => set({ brandsForPartnerDatatableOptions: options }),

	setBrandsForProducerDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({ brandsForProducerDatatableOptions: options }),
});
